module.exports = __webpack_public_path__ + "static/media/72.e6bb2798.jpg";